var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQcFileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#89F4A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1199 42.8569L31.6122 39.0303L33.0918 37.5507L35.1199 39.5788L39.699 34.9997L41.1786 36.7982L35.1199 42.8569ZM21.4082 42.6528C20.7316 42.6528 20.0827 42.384 19.6043 41.9056C19.1259 41.4272 18.8571 40.7783 18.8571 40.1018V19.6936C18.8571 18.2778 19.9924 17.1426 21.4082 17.1426H22.6837V26.0711L25.8725 24.1579L29.0612 26.0711V17.1426H36.7143C37.3909 17.1426 38.0397 17.4113 38.5181 17.8898C38.9965 18.3682 39.2653 19.017 39.2653 19.6936V31.6069C37.7898 31.0869 36.1905 31.0311 34.6824 31.4472C33.1743 31.8632 31.8298 32.7311 30.8296 33.934C29.8295 35.137 29.2217 36.6174 29.088 38.1761C28.9542 39.7348 29.301 41.297 30.0816 42.6528H21.4082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcFileImg);
export default __webpack_public_path__ + "static/media/qc-file-img.176076c9949ea00aef4b38b8871a2f4a.svg";
export { ForwardRef as ReactComponent };